import { WizardAction, WizardState } from "../types/WigWizard";

export function WigWizardReducer(state: WizardState, action: WizardAction): WizardState {
  switch (action.type) {
    case 'Animated':
      return {...state, skuImage: true};
    case 'Static':
      return {...state, skuImage: false};
    case 'Color':
      return { ...state, Color: action.value, clicked: 'Color' };
    case 'Length':
      return { ...state, Length: action.value, clicked: 'Length' };
    case 'Product':
      return { ...state, Product: action.value, clicked: 'Product' };
    case 'Type':
      return { ...state, Type: action.value, clicked: 'Type' };
    case 'Cut':
      return { ...state, Cut: action.value, clicked: 'Cut' };
    case 'Bang':
      return { ...state, Bang: action.value, clicked: 'Bang' };
    case 'Part_Style':
      return { ...state, Part_Style: action.value, clicked: 'Part_Style' };
      case 'Adhesive':
        return { ...state, Adhesive: action.value, clicked: 'Adhesive' };
    case 'Hair_Styling':
        return { ...state, Hair_Styling: action.value, clicked: 'Hair_Styling' };
    case 'Prep':
      return { ...state, Prep: action.value, clicked: 'Prep' };
    case 'Photo':
      const newState = { ...state }
      if (action.value) {
        newState.steps[state.active].img = action.value
        newState.active = state.active + 1
      }
      return newState
    case 'Uploading':
      return { ...state, active: state.active + 1 }
    case 'Uploaded':
      return {
        ...state,
        capSize: action.value.cap_size,
        laceTint: action.value.lace_tint,
        laceTintDescription: action.value.lace_tint_description,
        s3BucketFolder: action.value.s3_bucket_folder,
        redirectAfterLogin: action.value.redirectAfterLogin,
        active: state.active + 1,
        uploadedWithEmail: !!action.value.email,
      }
    case 'Error':
      return {
        ...state,
        error: action.value,
      }
    case 'ErrorContext':
      return {
        ...state,
        errorContext: action.value,
      }
    case 'ResolveError':
      return {
        ...state,
        active: 0,
        steps: [{}, {}, {}, {}],
        error: action.value,
      }
    case 'StartCamera':
      return {
        ...state,
        steps: [{}, {}, {}, {}],
        active: 0,
      }
    case 'SkippedToLastStep':
      return {
        ...state,
        skipToLastStep: false,
      }
    case 'CaptchaCompleted':
      return {
        ...state,
        captchaCompleted: true,
      }
    case 'FrontImage':
      return {
        ...state,
        frontImage: action.value,
      }
    case 'SkinTone':
      return {
        ...state,
        SkinTone: action.value,
      }
    default:
      throw new Error();
  }
}
